const navToggle = document.querySelector(".nav-toggle");
const siteNav = document.querySelector(".site-nav");

if (navToggle && siteNav) {
  const closeMenu = () => {
    navToggle.setAttribute("aria-expanded", "false");
    siteNav.classList.remove("is-open");
  };

  navToggle.addEventListener("click", () => {
    const isOpen = navToggle.getAttribute("aria-expanded") === "true";
    navToggle.setAttribute("aria-expanded", String(!isOpen));
    siteNav.classList.toggle("is-open", !isOpen);
  });

  siteNav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
    }
  });
}

const signupForm = document.querySelector(".signup-form");

if (signupForm instanceof HTMLFormElement) {
  const submitButton = signupForm.querySelector('button[type="submit"]');
  const feedback = signupForm.querySelector(".signup-feedback");
  const successBox = document.querySelector(".signup-success");
  const successMessage = successBox?.querySelector(".signup-success-message");

  const setFeedback = (message, kind) => {
    if (!feedback) {
      return;
    }

    feedback.textContent = message;
    feedback.classList.remove("is-success", "is-error");
    feedback.classList.add(kind === "error" ? "is-error" : "is-success");
    feedback.hidden = false;
  };

  const showSuccessMessage = (message) => {
    if (!(successBox instanceof HTMLElement) || !(successMessage instanceof HTMLElement)) {
      return;
    }

    successMessage.textContent = message;
    successBox.hidden = false;
  };

  signupForm.addEventListener("submit", async (event) => {
    event.preventDefault();
    let submittedSuccessfully = false;

    if (feedback) {
      feedback.hidden = true;
      feedback.textContent = "";
      feedback.classList.remove("is-success", "is-error");
    }

    if (submitButton instanceof HTMLButtonElement) {
      submitButton.disabled = true;
    }

    try {
      const formData = new FormData(signupForm);
      const encodedData = new URLSearchParams(formData).toString();
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encodedData,
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      signupForm.reset();
      signupForm.classList.add("is-hidden");
      showSuccessMessage("Vielen Dank. Ihre Anmeldung wurde erfolgreich gesendet.");
      submittedSuccessfully = true;
    } catch (error) {
      setFeedback(
        "Die Anmeldung konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.",
        "error",
      );
      console.error(error);
    } finally {
      if (!submittedSuccessfully && submitButton instanceof HTMLButtonElement) {
        submitButton.disabled = false;
      }
    }
  });
}
